import { useThemeStore } from "@stores/theme.store";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { IoCopy } from "react-icons/io5";
import copy from "copy-to-clipboard";
import moment from "moment";
import { Button, message } from "antd";
import { toRp } from "@utils/helper";
import { PopupConfirm } from "@components/general/popup";
import { NoticeType } from "antd/es/message/interface";
import { useMutation } from "@tanstack/react-query";
import { FinanceService } from "@services/finance.service";
export const VaDetailPage = () => {
  const { state } = useLocation();
  const { setHeader, setAppBar, setBottomNavigation } = useThemeStore(
    (state) => state
  );
  const [messageApi, contextHolder] = message.useMessage();
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const [showMessageText, setShowMessageText] = useState<string>("");
  const [messageType, setMessageType] = useState<string>("");
  const [trxID, setTrxID] = useState<string>("");
  const [popupTitle, setPopupTitle] = useState<string>("");
  const [popupMessage, setPopupMessage] = useState<string>("");
  const [popupTextConfirm, setPopupTextConfirm] = useState<string>("");
  const [popupCancel, setPopupCancel] = useState<boolean>(false);
  const [status, setStatus] = useState<string>(state?.vaStatus);

  const { mutate, isPending } = useMutation({
    mutationFn: FinanceService.virtualAccountCancel,
    onSuccess: (response) => {
      if (response.success) {
        setStatus("EXPIRED");
        setTrxID("");
        setShowMessage(true);
        setShowMessageText("Virtual account berhasil dibatalkan!");
        setMessageType("success");
      } else {
        setShowMessage(true);
        setShowMessageText(response.message);
        setMessageType("error");
      }
    },
    onError: (error: any) => {
      setShowMessage(true);
      setShowMessageText(error.message ?? "Internal Error");
      setMessageType("error");
    },
  });

  const handleConfirm = () => {
    setPopupCancel(false);
    mutate(trxID);
  };

  const onCopy = () => {
    copy(state?.vaNumber);
    setShowMessage(true);
    setShowMessageText("Nomor VA berhasil disalin!");
    setMessageType("success");
  };

  const onCopyNominal = () => {
    copy(state?.vaTrxAmount + 2000);
    setShowMessage(true);
    setShowMessageText("Nominal Pembayaran berhasil disalin!");
    setMessageType("success");
  };

  const onOpenPopupCancel = (id: string) => {
    setTrxID(id);
    setPopupTitle("Batalkan Pembayaran");
    setPopupMessage(
      "Jika dibatalkan maka status transaksi menjadi EXPIRED dan TIDAK BISA DIGUNAKAN KEMBALI"
    );
    setPopupTextConfirm("Ya, Batalkan");
    setPopupCancel(true);
  };

  useEffect(() => {
    setAppBar({ title: "Detail Laporan VA", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Detail Laporan VA",
    });
    setBottomNavigation("hidden");
  }, [setHeader, setAppBar, setBottomNavigation]);

  useEffect(() => {
    if (showMessage) {
      messageApi.open({
        type: messageType as NoticeType,
        content: <>{showMessageText}</>,
      });
    }
    setShowMessage(false);
  }, [showMessage, showMessageText]);

  return (
    <>
      {contextHolder}
      <div className="tw-px-4 tw-pb-20">
        <div className="tw-bg-other-100 tw-rounded-lg card-body">
          <div className="tw-text-primary-hg tw-text-xs">Status</div>
          <div className="tw-mb-3">
            {status === "PENDING" ? (
              <span className="tw-inline-flex tw-items-center tw-rounded-md tw-bg-yellow-50 tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-text-yellow-700 tw-ring-1 tw-ring-yellow-600/10 tw-ring-inset">
                PENDING
              </span>
            ) : status === "EXPIRED" ? (
              <span className="tw-inline-flex tw-items-center tw-rounded-md tw-bg-red-50 tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-text-red-700 tw-ring-1 tw-ring-red-600/10 tw-ring-inset">
                EXPIRED
              </span>
            ) : (
              <span className="tw-inline-flex tw-items-center tw-rounded-md tw-bg-green-50 tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-text-green-700 tw-ring-1 tw-ring-green-600/10 tw-ring-inset">
                COMPLETE
              </span>
            )}
          </div>

          <div className="tw-text-primary-hg tw-text-xs">ID Transaksi</div>
          <div className="tw-mb-3">{state.vaTrxId ?? "-"}</div>

          <div className="tw-text-primary-hg tw-text-xs">Nomor VA</div>
          <div
            className="tw-mb-3 tw-font-bold tw-tracking-wider"
            onClick={onCopy}
          >
            {state?.vaNumber ?? "-"}&nbsp;
            <i>
              <IoCopy />
            </i>
          </div>

          <div className="tw-text-primary-hg tw-text-xs">Atas Nama</div>
          <div className="tw-mb-3">{state.vaName ?? "-"}</div>

          <div className="tw-text-primary-hg tw-text-xs">Nama Bank</div>
          <div className="tw-mb-3">{state.vaBankName ?? "-"}</div>

          <div className="tw-text-primary-hg tw-text-xs">Nominal</div>
          <div className="tw-mb-3">{toRp(state?.vaTrxAmount ?? 0)}</div>

          <div className="tw-text-primary-hg tw-text-xs">Biaya Admin Bank</div>
          <div className="tw-mb-3">{toRp(state?.vaBankFee ?? 0)}</div>

          <div className="tw-text-primary-hg tw-text-xs">Total</div>
          <div className="tw-mb-3 tw-font-bold" onClick={onCopyNominal}>
            {state?.vaTrxAmount === 0
              ? toRp(state?.vaBankFee ?? 0)
              : toRp((state?.vaTrxAmount ?? 0) + (state?.vaBankFee ?? 0))}
            &nbsp;
            <i>
              <IoCopy />
            </i>
          </div>

          <div className="tw-text-primary-hg tw-text-xs">
            Tanggal Kadaluarsa
          </div>
          <div className="tw-mb-3">
            {moment(state.vaDateExpired ?? Date.now()).format(
              "dddd, DD MMMM YYYY | HH:mm"
            )}
          </div>
        </div>

        {status === "PENDING" && (
          <div className="tw-mt-4 tw-bg-other-100 tw-rounded-lg card-body">
            <Button
              type="primary"
              loading={isPending}
              className="tw-h-9 tw-w-full tw-bg-red-700 focus:tw-shadow-none hover:tw-bg-other-100 hover:tw-text-red-700 hover:tw-border-red-700"
              onClick={() => onOpenPopupCancel(state?.vaTrxId ?? "")}
            >
              Batalkan Pembayaran
            </Button>
          </div>
        )}
      </div>

      <PopupConfirm
        open={popupCancel}
        title={popupTitle}
        message={popupMessage}
        textConfirm={popupTextConfirm}
        textCancel="Batalkan"
        onConfirm={() => handleConfirm()}
        onCancel={() => setPopupCancel(false)}
      />
    </>
  );
};
